module.exports = __webpack_public_path__ + "ca3e913ca1e41f229c53acba75ad8b82.png";